import TwoLineCell from '@tcs/client-portal-common/components/molecules/Table/cells/TwoLineCell';

enum DocumentTaxFormType {
  UNKNOWN = 'Unknown',
  IRS1099R = 'IRS1099R',
  IRS5498 = 'IRS5498',
  IRS1099Q = 'IRS1099Q',
}

interface Props {
  taxFormType: string;
  fileName: string;
}

const documentByTaxTypeDictionary = {
  [DocumentTaxFormType.IRS1099R]: {
    code: '1099-R',
    message: 'Required to file to IRS',
  },
  [DocumentTaxFormType.IRS1099Q]: {
    code: '1099-Q',
    message: 'Required to file to IRS',
  },
  [DocumentTaxFormType.IRS5498]: {
    code: '5498',
    message: 'No action needed',
  },
};

export const DocumentCell = ({ taxFormType, fileName }: Props) => {
  if (!taxFormType) return null;

  const notFoundCodeDocument = {
    code: taxFormType,
    message: 'No action needed',
  };

  const { code, message } =
    documentByTaxTypeDictionary[taxFormType] || notFoundCodeDocument;

  const combinedText = `${code} - ${fileName}`;

  return <TwoLineCell primary={combinedText} secondary={message} />;
};

export default DocumentCell;
